import React, {useMemo} from "react";
import { CalendarSeeker } from "ui-seeker/core";
import { AppCalendarAddEventButton } from "./Events&Alerts";
import { useAppCalendar } from "./@hooks";
import AppCalendarCellContent from "./Cell";
import AppCalendarCellActions from "./CellActions";
import AppCalendarSliderColor from "./SliderColor";
import { CalendarLoading } from "app/components/loading";
import {AppNoDataCard} from "../../Base";
import {isEmpty} from "ui-seeker/utils";
import AppCalendarPriceByNight from './PriceByNight'


export function CalendarGrid({ calendarData, openDetailsModal, dates, showLocationData, integerPrices }) {

    if (dates.length) return dates.reduce((a, date) => ({
        ...a,
        [date]: {
            dayActions: <AppCalendarCellActions date={date} showLocationData={showLocationData} />
        }
    }), {})

    return Object.entries(calendarData).reduce((a, [date, { main, compset }]) => ({
        ...a,
        [date]: {
            content: <AppCalendarCellContent
                date={date}
                main={main}
                compset={compset}
                openDetailsModal={openDetailsModal}
                integerPrices={integerPrices}
            />,
            dayActions: <AppCalendarCellActions date={date} showLocationData={showLocationData} />
        }
    }), {})
}

export default function AppCalendarContent({ calendarData, dateRange, startDate, openDetailsModal, externalEvents, dates, showLocationData, integerPrices }) {
    const { month, year, isLoading } = useAppCalendar(dateRange, startDate, externalEvents);

    const dataList = useMemo(() =>
            CalendarGrid({ calendarData, openDetailsModal, dates, showLocationData, integerPrices }),
        [calendarData, dates, openDetailsModal, showLocationData, integerPrices]
    )

    if (!Object.values(calendarData).length && !isLoading && !dates.length) return <AppNoDataCard />
    if (isLoading) return <CalendarLoading />

    return <div className="mb-40 calendar-section calendar-competition">
        <div className="competition-toolbar app-calendar-toolbar">
            <div /> {/* relleno izq. — el grupo de toggles va a la derecha, como en el toolbar de las tablas */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <AppCalendarPriceByNight />
                <AppCalendarAddEventButton />
            </div>
        </div>
        <CalendarSeeker
            title=""
            data={dataList}
            month={month}
            year={year}
        >
            {!isEmpty(calendarData) && <AppCalendarSliderColor/>}
        </CalendarSeeker>
    </div>
}